import React, { useState, useEffect, useRef } from 'react';
import { IconButton, Slider, Tooltip } from '@mui/material';
import { AiFillMinusSquare } from "react-icons/ai";
import { FaPlus, FaMinus } from "react-icons/fa6";
import "./style.css"

const SFGoalSlider = ({ type, goal, previousGoal, handleGoalChange, min, max, step, disabled, locked }) => {

    const [val, setVal] = useState(null);

    useEffect(() => {
        if (goal !== undefined && goal !== val) {
            setVal(goal);
        }
    }, [goal]);

    const handleChange = (_, newValue) => {
        handleGoalChange(newValue);
    };

    const clamp = (value, min, max) => {
        return Math.max(min, Math.min(value, max));
    }

    return (
        <div className='d-flex justify-content-center align-items-start sf-goal-slider'>
            <IconButton
                disabled={disabled}
                className='mt-1 slider-icon' size='small' aria-label="delete"
                onClick={(e) => {
                    e.stopPropagation();
                    let newVal = val - 10;
                    newVal = clamp(newVal, 0, 100)
                    handleChange("", newVal);
                }}>
                <FaMinus color={disabled ? "gray" : "#BA0C2F"} />
            </IconButton>
            <Slider
                className={disabled ? "sf-accuracy-goal-slider slider-disabled" : "sf-accuracy-goal-slider"}
                disabled={disabled}
                min={min}
                step={step}
                sx={{
                    '& .MuiSlider-track': {
                        width: type === "time" ? `${(previousGoal * 10) / 100}% !important` : `${previousGoal}% !important`
                    }
                }}
                valueLabelDisplay="on"
                max={max}
                value={val}
                onClick={(e) => e.stopPropagation()}
                onChange={handleChange}
                marks={Array.from({ length: 10 }).map((v, index) => {
                    let markVal = index * step;
                    if (markVal !== val) {
                        return {
                            value: markVal,
                            label: markVal,
                        }
                    }
                    return {
                        value: 0,
                        label: 0,
                    };

                })}
            />
            <IconButton
                disabled={disabled}
                className='mt-1 slider-icon' size='small' aria-label="delete"
                onClick={(e) => {
                    e.stopPropagation();
                    let newVal = val + 10;
                    newVal = clamp(newVal, 0, 100)
                    handleChange("", newVal);
                }}>
                <FaPlus color={disabled ? "gray" : "#BA0C2F"} />
            </IconButton>
        </div>
    );
}

export default SFGoalSlider;
